import { HttpBackend, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

/** Redirect unauthenticated routes directly to the backend so they can
 *  be handled without any authentication
 */
@Injectable()
export class UnauthenticatedRouteInterceptor implements HttpInterceptor {
  // We do not want to perform a refresh on these routes
  private readonly unauthenticatedRoutes = ['user-invitations/check'];

  constructor(private backend: HttpBackend) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isUnauthenticated = !this.unauthenticatedRoutes.every((route) => !req.url.includes(route));
    // Skip auth0 interceptor for the following unauthenticated urls
    if (isUnauthenticated) {
      // If this route is to an unauthenticaed endpoint pass directly to the backend
      return this.backend.handle(req);
    }

    return next.handle(req);
  }
}
